/* eslint-disable angular/controller-as */

angular.
module("dx.webapp.library").
controller("DxLibraryExamItemController", function LibraryExamItemController(
	$element,
	$scope,
	$timeout,

	dxApi,
	dxLtiRoute,
	DX_URLS,
	dxSession
) {
	"use strict";

	$scope.dxSession = dxSession;
	$scope.dxLtiRoute = dxLtiRoute;
	$scope.Urls = DX_URLS;
	$scope.expanded = false;
	$scope.selected = false;
	$scope.loadingIndicator = false;
	$scope.loadingIndicatorDelay = 400;

	$scope.toggleExpand = function toggleExpand() {
		$scope.expanded = !$scope.expanded;
		if ($scope.expanded && $scope.exam.questions.length === 0) {
			getQuestions();
		}
	};

	$scope.toggleSelected = function toggleSelected($event) {
		$scope.selected = !$scope.selected;

		if ($scope.exam.questions.length === 0) {
			getQuestions();
		} else {
			$scope.dxExamLibraryCtrl.setExamSelected($scope.exam.id, $scope.selected, true);
		}

		$event.stopPropagation();
	};

	function getQuestions() {
		$timeout(showLoadingIndicator, $scope.loadingIndicatorDelay);
		dxApi.v1.examTemplates.questions.get($scope.exam.id).then(onGetQuestions);
	}

	function showLoadingIndicator() {
		if ($scope.exam.questions.length === 0) {
			$scope.loadingIndicator = true;
		}
	}

	function onGetQuestions(res) {
		$scope.exam.questions = res.data;

		if ($scope.selected === true) {
			// broadcast is set to false because the question directives have not been created yet so they will not receive the broadcast.
			// question directives check selectedquestionids in their link step instead.
			$scope.dxExamLibraryCtrl.setExamSelected($scope.exam.id, $scope.selected, false);
		}

		$scope.loadingIndicator = false;
	}

	$scope.$on("DxExamLibraryController:questionsSelectedUpdated", function updateSelected(event, selectedQuestionIds) {
		$scope.updateSelected(selectedQuestionIds);
	});

	$scope.updateSelected = function updateSelected(selectedQuestionIds) {
		var examItemCheckbox = $element.find(".examItemCheckbox")[0];
		var questions = $scope.exam.questions;
		var selectedQuestions = questions.filter(function selected(question) {
			return selectedQuestionIds.indexOf(question.id) !== -1;
		});

		if (selectedQuestions.length === 0) {
			examItemCheckbox.indeterminate = false;
			$scope.selected = false;
		} else if (selectedQuestions.length === questions.length) {
			examItemCheckbox.indeterminate = false;
			$scope.selected = true;
		} else {
			examItemCheckbox.indeterminate = true;
			$scope.selected = false;
		}
	};
});
